<div class="container">
  <h2>{{"WORKOUT.WORKOUT-DETAIL.REST"| translate}}</h2>

  <div class="circle-container">
    <svg style="margin-inline: auto" width="150" height="150" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">

      <circle cx="75" cy="75" r="66" stroke="#e6e6e6" stroke-width="8" fill="none" />
      <circle cx="75" cy="75" r="66" stroke="#db3687" stroke-width="8" fill="none"
        [attr.stroke-dasharray]="circumference" [attr.stroke-dashoffset]="offset" stroke-linecap="round"
        transform="rotate(-90 75 75)" />
    </svg>

    <div class="time">
      {{remainingTime * 1000 | date: 'mm:ss'}}
    </div>
  </div>
  <p *ngIf="exercise">{{"WORKOUT.WORKOUT-EXE.NEXT-EXE"| translate}}:</p>
  <div class="exercise" *ngIf="exercise">
    <ion-thumbnail>
      <img [src]="environment.exercises+'/'+exercise._id+'/images/main'">
    </ion-thumbnail>
    <div>
      <p class="exercise-name">{{exercise.i18nName[translate.currentLang.toUpperCase()]}}</p>
      <p class="exercise-infos" *ngIf="exercise.executionTimeSeconds > 0"><mat-icon svgIcon="mat:timer"></mat-icon>
        {{exercise.executionTimeSeconds}} {{"WORKOUT.WORKOUT-DETAIL.SECS" | translate}}</p>
      <p class="exercise-infos" *ngIf="exercise.executionTimeSeconds === 0"><mat-icon svgIcon="mat:fitness_center"></mat-icon>
        {{exercise.repetitions}} {{"WORKOUT.WORKOUT-DETAIL.REPS" | translate}}</p>
    </div>
  </div>
  <div class="footer-position">
    <button class="its-button" (click)="clearTimer()">{{"WORKOUT.WORKOUT-EXE.SKIP-BTN"| translate}}</button>
  </div>
</div>
